module.exports = __webpack_public_path__ + "img/mynumber-backup.22bba139.png";